
<div identity="c-card-options-wrap">

  <cvt-collapse
    :accordion="true"
    :theme="mode === 'LIGHT' ? 'light' : 'dark'"
    :prepend-chevron="prependChevron"
  >
    <cvt-collapse-item
      v-if="showOption('desktop')"
      name="build"
      title="Configurations"
      :initial-active="true"
      :special-style="isSpecialStyle"
    >
      <div class="row mb-3">
        <div class="col-12">
          <cvt-select
            mode="dropdown"
            :value="layout"
            label="Container Layout"
            :theme="mode"
            :background-mode="mode"
            @input="(value) => layout = value"
          >
            <option
              v-for="item in layouts"
              :key="item"
              :value="item"
              v-text="item"
            ></option>
          </cvt-select>
        </div>
      </div>

      <div class="divider mt-2" />
      <div class="row mb-3">
        <div class="col-12">
          <cvt-select
            mode="dropdown"
            :value="layoutView"
            label="View"
            :theme="mode"
            :background-mode="mode"
            @input="(value) => layoutView = value"
          >
            <option
              v-for="item in views"
              :key="item"
              :value="item"
              v-text="item"
            ></option>
          </cvt-select>
        </div>
      </div>
      <div class="divider mt-2" />

      <div class="row mb-3">
        <div class="col-12">
          <cvt-select
            mode="dropdown"
            :value="layoutWrap"
            label="Card Wrap"
            :theme="mode"
            :background-mode="mode"
            @input="(value) => layoutWrap = value"
          >
            <option
              v-for="item in layoutWrapOption"
              :key="item"
              :value="item"
              v-text="item"
            ></option>
          </cvt-select>
        </div>
      </div>
      <div class="divider mt-2" />
      <div class="row mb-3">
        <div class="col-12">
          <cvt-select
            mode="dropdown"
            :value="layoutSpacing"
            label="Card Spacing"
            :theme="mode"
            :background-mode="mode"
            @input="(value) => layoutSpacing = value"
          >
            <option
              v-for="item in layoutSpacingOption"
              :key="item"
              :value="item"
              v-text="item"
            ></option>
          </cvt-select>
        </div>
      </div>
      <div class="divider mt-2" />

      <div class="row">
        <div class="col-md-12 mb-3 d-flex align-items-center text-capitalize">
          Gap Between Cards
        </div>
        <div class="col-12">
          <cvt-slider
            id="slider-default"
            :tooltips-enabled="true"
            :step-marks-enabled="true"
            class="slider"
            :min="1"
            :max="100"
            :value="layoutGap"
            :step="1"
            @change="(value) => layoutGap = value"
          />
        </div>
      </div>
    </cvt-collapse-item>

    <cvt-collapse-item
      name="manage_list"
      title="Manage Cards"
      :initial-active="false"
      :special-style="isSpecialStyle"
    >
      <div class="row">
        <div class="col">
          <div class="form-fields">
            <div class="row">
              <div class="col-md-12">
                <draggable-list
                  :list="cardItems"
                  @change="updateCardFields"
                  @item-clicked="selectField"
                >
                  <template slot="list-item-template" slot-scope="props">
                    <cvt-icon
                      id="drag-handle"
                      :icon="iconConfig.leftSidebar.layout.drag || 'copy'"
                    />
                    <span :class="{ 'blue-text': false }">
                      {{ fmtFieldName(props.item, props.index) }}
                    </span>

                    <div
                      class="draggable-actions"
                      style="margin-left: auto"
                    >
                      <delete-button
                        :marked="markedForDeletion(props.index)"
                        @mark="markFieldForDeletion(props.index)"
                        @deleteForever="confirmFieldDeletion"
                      />
                    </div>
                  </template>
                </draggable-list>

                <cvt-button
                  :outlined="false"
                  :full-width="true"
                  text="Add Card"
                  :color="'LIGHT'"
                  @click="() => addCardField()"
                ></cvt-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </cvt-collapse-item>
  </cvt-collapse>
</div>
